import React from "react"
import { graphql } from "gatsby"

import ShopifyProduct from "../../components/shopifyProduct"
import ProductReviews from "../../components/shopifyProduct/reviews/ProductReviews"
import AcfProductContent from "../../components/shopifyProduct/acfProductContent/AcfProductContent"
import useAllCollections from "../../hooks/useAllCollections"

const DefaultPageTemplate = props => {
  const {
    data: {
      wpProduct: {
        acfProduct,
        acfProduct: {
          badge,
          shortDescription,
          paybrightFinancingAvailable,
          compatibleAppsApplications,
        },
        product,
      },
    },
  } = props
  const allBrands = useAllCollections()

  const brand =
    product?.vendor &&
    allBrands?.find?.(
      brand => brand.isBrand.isBrand && brand.title === product?.vendor
    )

  return (
    <>
      {product && (
        <ShopifyProduct
          badge={badge}
          paybrightFinancingAvailable={paybrightFinancingAvailable}
          product={product}
          shortDescription={shortDescription}
          brand={brand}
          compatibleApps={compatibleAppsApplications}
          buyersGuide={product?.collections[0]?.wpCollection?.buyersGuide?.text}
        />
      )}

      <AcfProductContent product={product} {...acfProduct} />

      {product && product?.reviews?.length >= 1 && (
        <ProductReviews product={product} reviews={product.reviews} />
      )}
    </>
  )
}

export default DefaultPageTemplate

export const CollectionQuery = graphql`
  query WpProductQuery($id: String!) {
    wpProduct(id: { eq: $id }) {
      ...WpProductFields
      product {
        ...ShopifyProductFields
        yotpoProductBottomLine {
          totalReviews
          score
        }
      }
    }
  }
`
